import { Heading } from '@simplywallst/ui-core/next';

import WarningSolid from '@simplywallst/ui-core/icons/WarningSolid';

export const ErrorState = () => {
  return (
    <div className="w-full max-w-screen-xl gap-x2 justify-self-center p-x2 md:pt-0 lg:mb-x2 lg:p-0 lg:px-x3">
      <div className="mt-x2 grid gap-x2 md:grid-cols-2 ">
        <div className="rounded-x1 bg-surface-1 px-x2 py-x3 md:rounded-x1 md:px-x4">
          <Heading
            as="h2"
            size="large"
            weight="strong"
            className="mb-x1 grid grid-cols-[max-content] items-center gap-x-1 text-solid"
          >
            <span>Returns Breakdown</span>
          </Heading>
          <div className="grid min-h-[310px] place-content-center">
            <span className="grid grid-cols-[24px_min-content] items-center justify-center gap-x0_25">
              <svg width="24" height="24" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="6" fill="#FFF" />
                <WarningSolid className="fill-bad" />
              </svg>
              <span className="text-nowrap text-xs text-soft">
                Something went wrong
              </span>
            </span>
          </div>
        </div>
        <div className="rounded-x1 bg-surface-1 px-x2 py-x3 md:rounded-x1 md:px-x4">
          <Heading
            as="h2"
            size="large"
            weight="strong"
            className="mb-x1 grid grid-cols-[max-content] items-center gap-x-1 text-solid"
          >
            <span>Contributors to Returns</span>
          </Heading>
          <div className="grid min-h-[310px] place-content-center">
            <span className="grid grid-cols-[24px_min-content] items-center justify-center gap-x0_25">
              <svg width="24" height="24" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="6" fill="#FFF" />
                <WarningSolid className="fill-bad" />
              </svg>
              <span className="text-nowrap text-xs text-soft">
                Something went wrong
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
